import {combineReducers} from 'redux';
import user from './user';
import login from './login';

const authReducers = combineReducers({
    user: user.Reducer,
    login: login.Reducer,
});

export default authReducers;


// WEBPACK FOOTER //
// ./src/store/actionreducers/auth/index.js